import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';

import cySelectors from '../../tests/cySelectors';

const SlidePillToggle = ({ options, value, onChange, label, name }) => {
  const [pillStyle, setPillStyle] = useState({});
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Find the button element corresponding to the active value
    const selectedButton = Array.from(container.children).find(
      (child) => child.getAttribute('data-value') === value,
    );

    // If the button is found, measure its dimensions and position
    if (selectedButton) {
      const { offsetWidth, offsetLeft } = selectedButton;
      const paddingOffset = container.children[0].offsetLeft;

      setPillStyle({
        width: `${offsetWidth}px`,
        transform: `translateX(${offsetLeft - paddingOffset}px)`,
      });
    }
  }, [value, options]);

  return (
    <div className="form__field__slide-pill">
      {label && (
        <label className="form__field__label" htmlFor={name}>
          {label}
        </label>
      )}
      <div className="form__field__slide-pill-toggle__container" ref={containerRef}>
        {options.map((option) => (
          <button
            key={option}
            name={name}
            id={name}
            type="button"
            onClick={() => onChange(option)}
            data-value={option}
            className={clsx('form__field__slide-pill-toggle__option', {
              'form__field__slide-pill-toggle__option--selected': value === option,
            })}
            data-cy={cySelectors.DETAILS_FORM_PILL}
          >
            {option}
          </button>
        ))}
        <div className="form__field__slide-pill-toggle__pill" style={pillStyle} />
      </div>
    </div>
  );
};

export default SlidePillToggle;
